<script setup lang="ts">
import { useAppBreadcrumbs } from '../lib/useAppBreadcrumbs';

const { items, visible, navigate } = useAppBreadcrumbs();
</script>

<template>
  <nav
    v-show="visible"
    class="app-breadcrumbs"
    aria-label="Навигация"
  >
    <ol class="app-breadcrumbs__list">
      <li
        v-for="(item, index) in items"
        :key="`${item.label}-${index}`"
        class="app-breadcrumbs__item"
      >
        <span
          v-if="index === items.length - 1 || (!item.to && !item.onClick)"
          class="app-breadcrumbs__current"
          :aria-current="index === items.length - 1 ? 'page' : undefined"
        >
          {{ item.label }}
        </span>
        <button
          v-else
          type="button"
          class="app-breadcrumbs__link"
          @click="navigate(item)"
        >
          {{ item.label }}
        </button>
      </li>
    </ol>
  </nav>
</template>
